module.exports = __webpack_public_path__ + "static/media/megali-paraskeui-bg.19e082f2.jpg";